import React from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import * as Yup from "yup";

import Button from "../../components/button";
import ICInput from "../../components/form/input";

const ConsultPmFeeForm = props => {
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      fee: props.fee ? props.fee : ""
    },
    validationSchema: Yup.object({
      fee: Yup.string().required(`Please enter ${props.feeName}`)
    }),
    onSubmit: values => {
      if (props.isCustomData) {
        props.onUpdateFormSubmit(values);
      } else {
        let formData = new FormData();
        formData.append("PMFee", values.fee);
        props.onUpdateFormSubmit(formData, "PMF");
      }
    }
  });

  return (
    <form
      className="d-flex flex-column mr-4 pr-4"
      onSubmit={formik.handleSubmit}
    >
      <div className="form-group row">
        <label className="col-sm-7 col-form-label">
          {props.feeName} <span className="error">*</span>:
        </label>
        <div className="col-sm-5">
          <ICInput
            name="fee"
            type="text"
            value={formik.values.fee}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </div>
      </div>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button title="Save" type="submit" />
      </p>
    </form>
  );
};

export default ConsultPmFeeForm;

ConsultPmFeeForm.defaultProps = {
  fee: "",
  feeName: "Practice Management Fee ($)",
  onUpdateFormSubmit: () => { },
  isCustomData: false,
};

ConsultPmFeeForm.propTypes = {
  fee: PropTypes.string,
  feeName: PropTypes.string,
  onUpdateFormSubmit: PropTypes.func,
  isCustomData: PropTypes.bool
};
